import { makeAutoObservable } from "mobx"
import AppState, { POPUPS } from "./AppState"

export class Group {
  groupId

  users = []

  progress = {} // permet d'enregistrer les progress des autres joueurs

  constructor(groupId) {

    this.groupId = groupId

    makeAutoObservable(this)
  }


  fetchInfos() {
    return new Promise( (resolve, reject) => {
      AppState.vertxClient.GroupCustomDataGetItem(this.groupId, "Infos", (success, msg, data) => {
        if(success) {
          Object.assign(this, data)
          resolve(data)
        }
        else {
          console.error("fetchInfos : " + msg)
          reject(msg)
        }
      })
    })
  }

  fetchUsers() {
    let user = AppState.vertxClient.UserData
    let universe = user.getUniverse()


    return new Promise( (resolve, reject) => {
      AppState.vertxClient.GroupAllUsersInfo(universe, this.groupId, (success, msg, data) => {
        if(success) {
          this.users = data.filter(u => !!u) // des users peuvent être null ...
          resolve(data)
        }
        else {
          console.log("ERROR fetch users", msg)
          reject(msg)
        }
      })

    })
  }

  updatePseudo(newValue) {
    return new Promise( (resolve, reject) => {
      const check_not_exist = false // on veut override
      const broadcast = true
      AppState.vertxClient.GroupCustomDataSetItem(this.groupId,"Infos.teamPseudo", newValue, check_not_exist, broadcast, (success, msg, data) => {

        if(success) {
          this.teamPseudo = newValue // on passe par les messages de groupe pour ça
          resolve()
        }
        else {
          console.log("Error update team pseudo", msg)
          reject(msg)
        }
      })
    })
  }


  fetchClassement(pageSize, pageOffset, sortFields, projection) {
    let params = {
      GenericFilters: { "CustomData.Infos": {$exists: true}},
      SortFields : sortFields,
      PageSize: pageSize,
      PageOffset: pageOffset,
      Projection: projection ,
      FindIndexes: {
        FullName: [this.groupId]
      }
    }

    if (!AppState.debugMode)
      params.GenericFilters["CustomData.Infos.enableRanking"] = {$eq: 1}

    return new Promise( (resolve, reject) => {
      AppState.vertxClient.GroupQuery(params, (success, msg, data) => {
        console.log("GroupQuery", success, msg, data)
        if(success) {
          resolve(data)
        }
        else {
          reject(msg)
        }


      })

    })


  }

}
